import AppSettings from './AppSettings';

export default AppSettings;
